import React from 'react';
import Select from 'react-select';
import api from '../../api';

export default class ClientCloseOffReasonsSelect extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            reasons: [],
            showAddFeatureField: false,
            showAddReasonField: false
        };
    }
    componentDidMount() {
        api.get('client_close_off_reasons').then(res => this.setState({reasons: res.value}));
    }
    handleChange(closeOffReasons) {
        this.props.onChange(closeOffReasons.split(","));
    }
    toggleAddFeature() {
        var isOn = this.state.showAddFeatureField;
        if(isOn) {
            this.setState({showAddFeatureField: false});
        } else {
            this.setState({showAddFeatureField: true, showAddReasonField: false, newFeatureText: 'Missing Feature: '});
        }
    }
    toggleAddReason() {
        var isOn = this.state.showAddReasonField;
        if (isOn) {
            this.setState({showAddReasonField: false});
        } else {
            this.setState({showAddReasonField: true, showAddFeatureField: false, newReasonText: ''});
        }
    }
    saveMissingFeature() {
        api.post('clients/dud_reasons', {reason: this.state.newFeatureText})
            .then(response => {
                this.setState({reasons: this.state.reasons.concat(response.value)})
            });
        this.setState({showAddFeatureField: false});
    }
    saveReason() {
        api.post('clients/dud_reasons', {reason: this.state.newReasonText})
            .then(response => {
                this.setState({reasons: this.state.reasons.concat(response.value)})
            });
        this.setState({showAddReasonField: false});
    }
    render() {
        var { reasons, showAddFeatureField, showAddReasonField } = this.state;
        var addReasonWrapper = {
            display: 'flex',
            marginRight: 15,
            marginBottom: 20
        };

        var missingFeaturesOptions = reasons
            .filter(r => r.reason.startsWith('Missing Feature'))
            .map(o => ({value: o.id, label: o.reason}));
        var missingFeatureLabel = missingFeaturesOptions.length ? [{
            label: "Missing Features",
            value: "Missing Features",
            disabled: true
        }] : [];
        
        var otherReasonsOptions = reasons
            .filter(r => !r.reason.startsWith('Missing Feature'))
            .map(o => ({value: o.id, label: o.reason}));
        var otherReasonsLabel = otherReasonsOptions.length ? [{
            label: "Other reasons",
            value: "Other reasons",
            disabled: true
        }] : [];

        var opts = missingFeatureLabel
            .concat(missingFeaturesOptions)
            .concat(otherReasonsLabel)
            .concat(otherReasonsOptions);

        return (
            <div style={{display: 'flex', flexDirection: 'column'}}>
                <div style={{float: 'right', marginRight: 15, fontSize: 11}}>
                    <a onClick={this.toggleAddReason.bind(this)} href="#">{showAddReasonField ? "cancel" : "Add Reason"}</a>
                    <span style={{marginRight: 5, marginLeft: 5}}>|</span>
                    <a href="#" onClick={this.toggleAddFeature.bind(this)}>{showAddFeatureField ? "cancel" : "Add Missing Feature"}</a>
                </div>
                {showAddFeatureField &&
                <div style={addReasonWrapper}>
                    <input autoFocus={true} onChange={({target}) => this.setState({newFeatureText: target.value})} placeholder="Enter missing feature" value={this.state.newFeatureText} className="form-control" />
                    <button onClick={this.saveMissingFeature.bind(this)} className="btn btn-success">Save</button>
                </div>
                }
                {showAddReasonField &&
                <div style={addReasonWrapper}>
                    <input autoFocus={true} onChange={({target}) => this.setState({newReasonText: target.value})} placeholder="Enter reason" value={this.state.newReasonText} className="form-control" />
                    <button onClick={this.saveReason.bind(this)} className="btn btn-success">Save</button>
                </div>
                }
                <Select
                    ref="select"
                    placeholder={'Select close off reasons'}
                    allowCreate={false}
                    multi={true}
                    name="form-field-name"
                    value={this.props.value.join(",")}
                    options={opts}
                    onChange={this.handleChange.bind(this)} />
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./app/components/clients/ClientCloseOffReasonsSelect.js